import { Module, VuexModule, Action } from "vuex-module-decorators";
import { ERROR_NOTIFICATION_TYPE, SUCCESS_NOTIFICATION_TYPE } from "@/constants/notification";
import { app } from "@/main";
import { AxiosError } from "axios";

@Module({ name: "MToaster", namespaced: true })
export default class MToaster extends VuexModule {
  @Action
  emitError(e: any) {
    if (e as AxiosError) {
      app.$root.$emit("show-notification", {
        type: ERROR_NOTIFICATION_TYPE,
        title: e.response?.data.message,
        // TODO: discuss with design error handaling visual
        // message: e.response?.status.toString(),
        message: "",
      });
    } else if (e as string) {
      app.$root.$emit("show-notification", {
        type: ERROR_NOTIFICATION_TYPE,
        title: e,
      });
    } else {
      app.$root.$emit("show-notification", {
        type: ERROR_NOTIFICATION_TYPE,
        title: app.$root.$tc("error.default"),
      });
    }
  }

  @Action
  emitSuccess({ title, message }: { title: string; message: string }) {
    app.$root.$emit("show-notification", {
      type: SUCCESS_NOTIFICATION_TYPE,
      title,
      message,
    });
  }
}
